export default __webpack_public_path__ + "static/107998-3c694f69b01d71b7f4cbae709b317b65.jpg";